import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
export default {
  name: "orderList",
  mixins: [loadMoreList, serchSelect],
  data: function data() {
    return {
      pagingReqFn: "orderList",
      pagingReqValue: "data",
      gameList: [],
      GamesServersList: [],
      value2: [],
      stateList: [{
        label: '已支付',
        value: '1'
      }, {
        label: '未支付',
        value: '2'
      }]
    };
  },
  activated: function activated() {
    var _this = this;

    this.getlangList();
    this.$api.paymentGamesData().then(function (res) {
      if (res.code == 0) {
        _this.gameList = res.data;
      }
    });
    this.$api.paymentGamesServersAll().then(function (res) {
      if (res.code == 0) {
        _this.GamesServersList = res.data;
      }
    });
  },
  created: function created() {
    this.getList();
  },
  methods: {
    dateChange: function dateChange(e) {
      console.log(this.value2);
      this.paramsData.start_time = this.value2 ? this.value2[0] : '';
      this.paramsData.end_time = this.value2 ? this.value2[1] : '';
    },
    del: function del(data) {
      var _this2 = this;

      var ids = data.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'paymentGamesDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this2.getList();
      });
    }
  }
};